/** BCP 47 tag for `toLocaleDateString` / `toLocaleString` from i18next language code. */
export function tenderUiLocaleTag(lang: string): string {
  switch (lang) {
    case "sv":
      return "sv-SE"
    case "en":
      return "en-GB"
    case "de":
      return "de-DE"
    case "fi":
      return "fi-FI"
    case "no":
      return "nb-NO"
    default:
      return lang
  }
}
